import { boolean, object, array, string, mixed } from 'yup';

const makeSchema = (data, isShortlisted, doNotvalidate) => {
  if (!data) return;
  let schema = {};

  for (let prop in data) {
    schema[prop] = boolean().test('checked', 'Required', value => {
      return value;
    });
  }

  schema = {
    ...schema,
    photo: mixed().notRequired(),
    photo1: mixed().notRequired(),
    photo2: mixed().notRequired(),

    attachmentFile1: mixed().notRequired(),
    attachmentFile2: mixed().notRequired(),
    attachmentFile3: mixed().notRequired(),
    attachmentFile4: mixed().notRequired(),
    attachmentFile5: mixed().notRequired(),
    attachmentFile6: mixed().notRequired(),
    attachmentFile7: mixed().notRequired(),

    file1: mixed().notRequired(),
    file2: mixed().notRequired(),
    file3: mixed().notRequired(),

    url: string()
      .required('URL is required field!')
      .url('URL is not valid!'),
    // note: string().required('Note is required field!'),
    slipNote: string().required('Required'),
    ies: mixed()
      .nullable()
      .test('ies', 'You have to select Photometric data or CAD file', value => {
        // if (value) return true;
        // return false;
        return true;
      }),
  };

  if (isShortlisted) {
    schema = {
      ...schema,
      luminaireImage: doNotvalidate
        ? mixed().notRequired()
        : mixed()
            .required('Please upload images as indicated!')
            .nullable()
            .test('luminaireImage', 'You have to select image file!', value => {
              if (value) return true;
              return false;
            }),
      polarDiagramImage: doNotvalidate
        ? mixed().notRequired()
        : mixed()
            .required('Please upload images as indicated!')
            .nullable()
            .test(
              'polarDiagramImage',
              'You have to select image file!',
              value => {
                if (value) return true;
                return false;
              }
            ),
      dimensionsImage: doNotvalidate
        ? mixed().notRequired()
        : mixed()
            .required('Please upload images as indicated!')
            .nullable()
            .test(
              'dimensionsImage',
              'You have to select image file!',
              value => {
                if (value) return true;
                return false;
              }
            ),
      quotation: doNotvalidate
        ? mixed().notRequired()
        : mixed()
            .required('You are required to upload a document with budget pricing!')
            .nullable()
            .test('quotation', 'You are required to upload a document with budget pricing file!', value => {
              if (value) return true;
              return false;
            }),
      criteriaValues: mixed()
        .notRequired()
        .nullable(),
      generalNotes: string().notRequired(),
    };
    delete schema.slipNote;
  }

  return object().shape(schema);
};

export default makeSchema;
